
// import axios from "axios";
// import { renewToken } from "../services/auth.service";
// import * as MyStorage from "./myStorage";
// import config from "../config";

// const ApiUrl = config().API_URL;
// const partnerUrl = config().PARTNER_URL;

// /** Axios instance’ları */
// const axiosInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosPartnerInstance = axios.create({
//   baseURL: partnerUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     "Connection-code": MyStorage.AppCache.getSelectedConnection()?.code || "",
//     jwt: (() => {
//       const accessToken = MyStorage.AppCache.getApplicationJwt();
//       const partnerToken = MyStorage.getServiceToken2(502);
//       return accessToken && partnerToken ? `${accessToken}.${partnerToken}` : "";
//     })(),
//   },
// });

// export const axiosPublicInstance = axios.create({
//   baseURL: ApiUrl,
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//   },
// });

// export const axiosInstanceForMail = axios.create({
//   headers: {
//     Accept: "application/json",
//     "Content-Type": "application/json",
//     Jwt: MyStorage.getLinkForMail() || "",
//   },
// });

// /** Response handle */
// const handleResponse = (response) => response.data;

// /** Error handle */
// const handleErrorResponse = async (error) => {
//   const { config, response } = error;
//   if (!response) return Promise.reject(error);

//   let resData = response.data;

//   if (typeof resData === "string") {
//     try { resData = JSON.parse(resData); } catch(e) { return Promise.reject(error); }
//   }

//   console.log("API ERROR:", response.status, resData);

//   // Expired JWT veya 401 kontrolü
//   if (
//     resData?.error?.code === 1023 ||
//     resData?.error?.message?.includes("Expired JWT") ||
//     response.status === 401
//   ) {
//     // Her durumda logout
//     MyStorage.AppCache.onLoggout();
//     window.location.href = "/authentication";
//     return Promise.reject("Session Expired");
//   }

//   return Promise.reject(resData || error);
// };


// /** Request handle */
// const handleRequest = async (req) => {
//   const token = MyStorage.AppCache.getApplicationJwt();
//   if (token) req.headers["application-jwt"] = token;
//   return req;
// };

// const handlePartnerRequest = async (req) => {
//   const accessToken = MyStorage.AppCache.getApplicationJwt();
//   const partnerToken = MyStorage.getServiceToken2(502);
//   if (accessToken && partnerToken) {
//     req.headers["jwt"] = `${accessToken}.${partnerToken}`;
//   }
//   return req;
// };

// const handleRequestError = (error) => Promise.reject(error);

// /** Interceptor’ları bağla */
// // Request interceptor
// axiosInstance.interceptors.request.use(handleRequest, handleRequestError);
// axiosPartnerInstance.interceptors.request.use(handlePartnerRequest, handleRequestError);
// axiosInstanceForMail.interceptors.request.use(handleRequest, handleRequestError);

// // Response interceptor
// axiosInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosPartnerInstance.interceptors.response.use(handleResponse, handleErrorResponse);
// axiosInstanceForMail.interceptors.response.use(handleResponse, handleErrorResponse);

// // Public instance
// axiosPublicInstance.interceptors.request.use((req) => {
//   let token = MyStorage.getAccessToken();
//   if (token) req.headers["application-jwt"] = token;
//   return req;
// }, handleRequestError);

// axiosPublicInstance.interceptors.response.use(handleResponse, handleErrorResponse);

// export default axiosInstance;

import axios from "axios";
import { renewToken } from "../services/auth.service";
import * as MyStorage from "./myStorage";
import config from "../config";

const CFG = config();
const ApiUrl = CFG.API_URL;
const partnerUrl = CFG.PARTNER_URL;
const helpUrl = CFG.HELP_URL;

/** Axios instance’ları */
const axiosInstance = axios.create({
  baseURL: ApiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosPartnerInstance = axios.create({
  baseURL: partnerUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // DİKKAT: connection-code ve jwt burada sabitlenmiyor; interceptor'da dinamik eklenecek
  },
});

export const axiosPublicInstance = axios.create({
  baseURL: ApiUrl,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});

export const axiosInstanceForMail = axios.create({
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Jwt: MyStorage.getLinkForMail?.() || "",
  },
});

/** Response handle */
const handleResponse = (response) => response.data;

/** Error handle */
const handleErrorResponse = async (error) => {
  const { config: reqConfig, response } = error;
  if (!response) return Promise.reject(error);

  let resData = response.data;
  if (typeof resData === "string") {
    try { resData = JSON.parse(resData); } catch { /* ignore */ }
  }

  // Bu istek HELP domain'ine mi gidiyor?
  const isHelpCall =
    (reqConfig?.baseURL && helpUrl && String(reqConfig.baseURL).startsWith(helpUrl)) ||
    (reqConfig?.url && helpUrl && String(reqConfig.url).startsWith(helpUrl));

  console.log("API ERROR:", response.status, resData, { isHelpCall });

  // Expired JWT / 401
  const isExpired =
    resData?.error?.code === 1023 ||
    /Expired JWT/i.test(resData?.error?.message || "");

  if (isExpired || response.status === 401) {
    if (!isHelpCall) {
      // Sadece AUTH/PARTNER çağrılarında logout et
      MyStorage.AppCache?.onLoggout?.();
      window.location.href = "/authentication";
      return Promise.reject("Session Expired");
    }
    // HELP çağrılarında logout yapma; UI tarafı hatayı yönetsin
    return Promise.reject(resData || error);
  }

  return Promise.reject(resData || error);
};

/** Request handle */
const handleRequest = async (req) => {
  const token =
    MyStorage.AppCache?.getApplicationJwt?.() ||
    MyStorage.getAccessToken?.();
  if (token) req.headers["application-jwt"] = token;
  return req;
};

// Partner/Help type istekler için jwt ve connection-code başlıklarını ekle
const handlePartnerRequest = async (req) => {
  const accessToken =
    MyStorage.AppCache?.getApplicationJwt?.() ||
    MyStorage.getAccessToken?.() ||
    "";

  // Partner/service token — HELP için iki parçalı jwt gerekiyor
  const partnerToken =
    MyStorage.AppCache?.getServiceJWT?.(503) ||
    MyStorage.getServiceToken2?.(503) ||
    MyStorage.getServiceToken2?.(502) ||
    "";

  // Doküman: header adı tamamen küçük
  const cc =
    MyStorage.AppCache?.getSelectedConnection?.()?.code ||
    CFG.CONNECTION_CODE ||
    "PARTNER";

  req.headers["connection-code"] = cc;

  if (accessToken && partnerToken) {
    req.headers.jwt = `${accessToken}.${partnerToken}`; // arada NOKTA şart
  } else {
    console.warn("[AXIOS][PARTNER] Missing tokens for jwt", {
      hasAccess: !!accessToken,
      hasPartner: !!partnerToken,
      cc,
    });
    // İstersen sadece access gönderme; HELP 1022 “Missing '.'” döner.
    req.headers.jwt = accessToken || "";
  }

  // Bazı gateway'ler istiyor
  req.headers.consumer = "apidoc";

  return req;
};

const handleRequestError = (error) => Promise.reject(error);

/** Interceptor’ları bağla */
// Request
axiosInstance.interceptors.request.use(handleRequest, handleRequestError);
axiosPartnerInstance.interceptors.request.use(handlePartnerRequest, handleRequestError);
axiosInstanceForMail.interceptors.request.use(handleRequest, handleRequestError);

// Response
axiosInstance.interceptors.response.use(handleResponse, handleErrorResponse);
axiosPartnerInstance.interceptors.response.use(handleResponse, handleErrorResponse);
axiosInstanceForMail.interceptors.response.use(handleResponse, handleErrorResponse);

// Public instance
axiosPublicInstance.interceptors.request.use((req) => {
  const token = MyStorage.getAccessToken?.();
  if (token) req.headers["application-jwt"] = token;
  return req;
}, handleRequestError);

axiosPublicInstance.interceptors.response.use(handleResponse, handleErrorResponse);

export default axiosInstance;
